import { CheckoutContactForm } from '@checkout-v2/const';
import { Action } from '@ngrx/store';

export const SET_CHECKOUT_CONTACTS = '[Checkout] Set checkout contacts';
export const RESET_CHECKOUT_CONTACTS = '[Checkout] Reset checkout contacts';

export class SetCheckoutContacts implements Action {
  readonly type = SET_CHECKOUT_CONTACTS;

  constructor(public payload: CheckoutContactForm) {}
}

export class ResetCheckoutContacts implements Action {
  readonly type = RESET_CHECKOUT_CONTACTS;
}

export type ContactsActions = SetCheckoutContacts | ResetCheckoutContacts;
